import { ReactElement } from "react";
import FlexRow from "../../layout/Flexbox/FlexRow";

type Props = {
    label: string;
    value?: string;
    onSelect?: () => void;
    iconSrc?: string;
};

export default function DropdownSelectorItem({
    label,
    value,
    onSelect,
    iconSrc,
}: Props): ReactElement {
    return (
        <FlexRow
            className="option-style"
            width="auto"
            gap={16}
            onClick={(e) => {
                onSelect?.();
                e?.stopPropagation();
            }}
        >
            {iconSrc != null && <img className="icon-style" src={iconSrc} />}
            {label}
        </FlexRow>
    );
}
